import { applyAdvancedFilterRows } from "./advancedFilter";

const TASK_PRIORITY_LABELS = new Set(["Low", "Medium", "High"]);

/**
 * Canonical task priority for list filtering (case-insensitive; empty = unset).
 * @param {unknown} raw
 * @returns {string} Low | Medium | High | ""
 */
export function normalizeTaskPriorityForFilter(raw) {
  const t = raw != null ? String(raw).trim() : "";
  if (!t) return "";
  if (TASK_PRIORITY_LABELS.has(t)) return t;
  const lower = t.toLowerCase();
  if (lower === "low") return "Low";
  if (lower === "medium") return "Medium";
  if (lower === "high") return "High";
  return t;
}

/**
 * @param {object} task
 * @param {string} keyword
 */
function taskNameOrNotesMatches(task, keyword) {
  const q = String(keyword || "").trim().toLowerCase();
  if (!q) return true;
  const name = task?.name != null ? String(task.name).toLowerCase() : "";
  const notes = task?.notes != null ? String(task.notes).toLowerCase() : "";
  return name.includes(q) || notes.includes(q);
}

/**
 * @param {object} task
 * @param {string} projectId
 */
function taskProjectIdMatches(task, projectId) {
  const pid = String(projectId || "").trim();
  if (!pid) return true;
  return String(task?.project_id || "") === pid;
}

/**
 * @param {object} task
 * @param {string} priorityValue — Low | Medium | High | __not_set__
 */
function taskPriorityMatches(task, priorityValue) {
  const v = String(priorityValue || "").trim();
  if (!v) return true;
  const raw = normalizeTaskPriorityForFilter(task?.priority);
  if (v === "__not_set__") return raw === "";
  return raw === normalizeTaskPriorityForFilter(v);
}

const TASK_ADVANCED_MATCHERS = {
  nameNotes: (task, value) => taskNameOrNotesMatches(task, value),
  project_id: (task, value) => taskProjectIdMatches(task, value),
  priority: (task, value) => taskPriorityMatches(task, value),
};

/**
 * @param {object[]} tasks
 * @param {Record<string, *>} criteria
 */
export function filterTasksByAdvancedCriteria(tasks, criteria) {
  return applyAdvancedFilterRows(tasks, criteria, { matchers: TASK_ADVANCED_MATCHERS });
}
